import React, { useEffect } from 'react';
import { Grid, TextField, MenuItem } from '@material-ui/core';

/* =======================
    STEP 1 — Resumen de Gestión
   ======================= */
function ResumenGestion({ state, onChange }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Resumen de la gestión surtida en la ruta"
                    name="resumen_gestion"
                    placeholder="Describa las acciones realizadas por las instancias de la Universidad..."
                    value={safeValue('resumen_gestion')}
                    onChange={onChange}
                    error={!!safeError('resumen_gestion')}
                    helperText={safeError('resumen_gestion')}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Verificación de los compromisos adquiridos"
                    name="verificacion_compromisos"
                    placeholder="Detalle el estado de cumplimiento de los acuerdos..."
                    value={safeValue('verificacion_compromisos')}
                    onChange={onChange}
                    error={!!safeError('verificacion_compromisos')}
                    helperText={safeError('verificacion_compromisos')}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Situación actual del interesado"
                    name="situacion_actual"
                    placeholder="Describa el estado actual de la persona atendida..."
                    value={safeValue('situacion_actual')}
                    onChange={onChange}
                    error={!!safeError('situacion_actual')}
                    helperText={safeError('situacion_actual')}
                />
            </Grid>
        </Grid>
    );
}

/* =======================
    STEP 2 — Verificación y Situación Actual
   ======================= */
function VerificacionSituacion({ state, onChange, solicitud }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');

        useEffect(() => {
    
                if (solicitud?.usuario_registro) {
        
                    const usuario = solicitud.usuario_registro;
        
                    const nombreCompleto = `
                        ${usuario.primer_nombre || ''} 
                        ${usuario.segundo_nombre || ''} 
                        ${usuario.primer_apellido || ''} 
                        ${usuario.segundo_apellido || ''}
                    `.replace(/\s+/g, ' ').trim();
    
                    onChange({
                        target: {
                            name: 'nombre_completo',
                            value: nombreCompleto
                        }
                    });
        
                    onChange({
                        target: {
                            name: 'documento_identidad',
                            value: usuario.identificacion || ''
                        }
                    });
    
                    onChange({
                        target: {
                            name: 'numero_contacto',
                            value: usuario.celular || usuario.telefono || ''
                        }
                    });
                }
            }, [solicitud]);

    return (
        <Grid container spacing={3}>

            <Grid item xs={12} md={6}>
                <TextField
                    select
                    fullWidth
                    label="Activación de la fase 1. ATE. EMERGENCIA"
                    name="activacion_fase1"
                    value={safeValue('activacion_fase1')}
                    onChange={onChange}
                    error={!!safeError('activacion_fase1')}
                    helperText={safeError('activacion_fase1')}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    select
                    fullWidth
                    label="Activación de la fase 6. MED. PROTECCIÓN"
                    name="activacion_medidas_proteccion"
                    value={safeValue('activacion_medidas_proteccion')}
                    onChange={onChange}
                    error={!!safeError('activacion_medidas_proteccion')}
                    helperText={safeError('activacion_medidas_proteccion')}
                >
                    <MenuItem value="SI">Sí</MenuItem>
                    <MenuItem value="NO">No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre Completo"
                    name="nombre_completo"
                    value={safeValue('nombre_completo')}
                    onChange={onChange}
                    error={!!safeError('nombre_completo')}
                    helperText={safeError('nombre_completo')}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    label="Documento de Identidad"
                    name="documento_identidad"
                    value={safeValue('documento_identidad')}
                    onChange={onChange}
                    error={!!safeError('documento_identidad')}
                    helperText={safeError('documento_identidad')}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Lugar de Expedición"
                    name="lugar_expedicion"
                    value={safeValue('lugar_expedicion')}
                    onChange={onChange}
                    error={!!safeError('lugar_expedicion')}
                    helperText={safeError('lugar_expedicion')}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    label="Número de contacto"
                    name="numero_contacto"
                    value={safeValue('numero_contacto')}
                    onChange={onChange}
                    error={!!safeError('numero_contacto')}
                    helperText={safeError('numero_contacto')}
                />
            </Grid>
      

        </Grid>
    );
}

export const Formulario009Steps = [
    {
        label: 'Resumen de Gestión',
        render: (props) => <ResumenGestion {...props} />
    },
    {
        label: 'Verificación y Estado',
        render: (props) => <VerificacionSituacion {...props} />
    }
];